import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    noDataText: {
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.spacing(2),
        color: theme.palette.primary.main,
    },
}))
const NoData = ({ statName }) => {
    const classes = useStyles()

    return (
        <Typography className={classes.noDataText}>{statName} data not available for this review type</Typography>
    )
}

export default NoData